import { notification } from 'antd';
import { remove } from 'lodash';

import { areAllFieldsEmpty } from '@/src/search/utils';
import { convertMomentToDate } from '@/utils/dateTimeHelpers';
import { addTransformUtils } from '@/utils/formHelpers';

const search = (values, searchOptions) => {
  const _values = { ...values };
  const copyFieldOptions = addTransformUtils(_values, searchOptions);

  const payload = {
    searchId: null,
    personId: 0,
    fullName: null,
    searchDescription: null,
    includeOnHome: null,
    searchText: _values.searchText || null,
    states: copyFieldOptions.getFullComplex('states', 'stateCode'),
    charts: copyFieldOptions.getFullComplex('charts', 'chartId'),
    categories: _values.categories ? [{ categoryId: _values.categories }] : [],
    dateStart: Array.isArray(_values.dateRanges) ? convertMomentToDate(_values.dateRanges[0]) : null,
    dateEnd: Array.isArray(_values.dateRanges) ? convertMomentToDate(_values.dateRanges[1]) : null,
    page: null,
    pageSize: null,
    sortField: null,
    sortOrder: null,
  };

  return payload;
};

const saveSearch = ({ values, form, options, initialData = {} }) => {
  if (areAllFieldsEmpty(form)) {
    notification.error({
      message: 'Search',
      description: 'Search option is required.',
    });
    return;
  }

  const _values = { ...values };
  const copyFieldOptions = addTransformUtils(_values, options);

  const payload = {
    ...initialData,
    ..._values,

    personId: initialData.personId,

    searchDescription: _values.searchDescription || initialData.searchDescription || null,
    includeOnHome: _values.includeOnHome || initialData.includeOnHome || 'N',
    searchText: _values.searchText || null,

    states: copyFieldOptions.getFullComplex('states', 'stateCode'),
    charts: copyFieldOptions.getFullComplex('charts', 'chartId'),
    categories: _values.categories ? [{ categoryId: _values.categories }] : [],

    dateStart: _values.dateStart || null,
    dateEnd: _values.dateEnd || null,

    page: initialData.page || null,
    pageSize: initialData.pageSize || null,
    sortField: initialData.sortField || null,
    sortOrder: initialData.sortOrder || null,
  };

  delete payload.dateRanges;

  return payload;
};

const isSearchFiltersEmpty = form => {
  const { getFieldsValue } = form;
  const fieldsValues = getFieldsValue();
  const _copy = { ...fieldsValues };

  const values = Object.values(_copy);

  remove(values, field => {
    if (Array.isArray(field)) {
      if (field.length < 1) {
        return true;
      }
    } else if (!field) {
      return true;
    }
    return false;
  });

  return values.length < 1;
};

export { search, saveSearch, isSearchFiltersEmpty };